import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ph--subtitles-bold-hide",
  "use": "icon-ph--subtitles-bold-hide-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-ph--subtitles-bold-hide\"><path fill=\"currentColor\" d=\"M20 4H6.83l2 2H20v11.17l1.76 1.76c.15-.28.24-.59.24-.93V6c0-1.1-.9-2-2-2\" /><path fill=\"currentColor\" d=\"M18 10h-5.17l2 2H18zM1.04 3.87l1.2 1.2C2.09 5.35 2 5.66 2 6v12c0 1.1.9 2 2 2h13.17l2.96 2.96l1.41-1.41L2.45 2.45zM4 6.83L7.17 10H6v2h2v-1.17L11.17 14H6v2h7.17l2 2H4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol